import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container", "track"]
    static values = {
        speed: { type: Number, default: 30 },
        paused: { type: Boolean, default: false }
    }

    connect() {
        this.#setupEventListeners()
        this.#startAnimation()
    }

    disconnect() {
        this.#stopAnimation()
    }

    pause() {
        this.pausedValue = true
        this.trackTarget.style.animationPlayState = 'paused'
    }

    resume() {
        this.pausedValue = false
        this.trackTarget.style.animationPlayState = 'running'
    }

    toggle() {
        if (this.pausedValue) {
            this.resume()
        } else {
            this.pause()
        }
    }

    // 私有方法
    #setupEventListeners() {
        // 鼠标悬停时暂停
        this.containerTarget.addEventListener('mouseenter', () => this.pause())
        this.containerTarget.addEventListener('mouseleave', () => this.resume())

        // 触摸设备支持
        this.containerTarget.addEventListener('touchstart', () => this.pause())
        this.containerTarget.addEventListener('touchend', () => this.resume())
    }

    #startAnimation() {
        if (this.trackTarget) {
            this.trackTarget.style.animationDuration = `${this.speedValue}s`
        }
    }

    #stopAnimation() {
        if (this.trackTarget) {
            this.trackTarget.style.animationPlayState = 'paused'
        }
    }
}
